<template>
    <div v-if="loading" class="loading-mask">
        <div class="loading-content">
            <div class="loading-spinner" :style="{ borderTopColor: color, borderRightColor: color }"></div>
            <div class="loading-text" :style="{ color: color }">加载中...</div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Loading',
    props: {
        loading: {
            type: Boolean,
            default: false
        },
        color: {
            type: String,
            default: '#409eff' // 默认蓝色
        }
    }
}
</script>

<style scoped>
.loading-mask {
    position: absolute;
    z-index: 100;
    background-color: rgba(255, 255, 255, 0.9);
    margin: 0;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    justify-content: center;
    align-items: center;
}

.loading-content {
    display: flex;
    flex-direction: column;
    align-items: center;
}

.loading-spinner {
    width: 40px;
    height: 40px;
    border: 3px solid rgba(0, 0, 0, 0.1);
    border-radius: 50%;
    border-top-color: transparent;
    border-right-color: transparent;
    animation: spin 0.8s linear infinite;
    margin-bottom: 10px;
}

.loading-text {
    font-size: 14px;
    letter-spacing: 1px;
}

@keyframes spin {
    0% {
        transform: rotate(0deg);
    }

    100% {
        transform: rotate(360deg);
    }
}
</style>